// websocket.service.ts
import { Injectable } from '@angular/core';
import { AuthState } from '@core/modules/auth/state/auth.state';
import { environment } from '@env/environment';
import { select } from '@ngxs/store';
import { EventNames } from '@socket.io/component-emitter';
import { Observable } from 'rxjs';
import { io } from 'socket.io-client';
import { AppPersistedState } from '@app-state/app.persisted.state';
import { ChatWsClient, ChatWsEmitEventsMap, ChatWsResponse } from './chat-ws.types';

@Injectable({
  providedIn: 'root'
})
export class ChatWsService {
  public io!: ChatWsClient;

  readonly #token = select(AuthState.accessToken);
  readonly #language = select(AppPersistedState.language);

  connect() {
    if (!environment.urls.chatWs) return;
    const serviceUrl = new URL(environment.urls.chatWs);
    const host = serviceUrl.origin;
    const path = serviceUrl.pathname;

    this.io = io(host, {
      path,
      transports: ['websocket'],
      //parser,
      auth: {
        Authorization: `Bearer ${this.#token()}`,
        'X-API-Key': environment.urls.chatApiKey,
        Prefer: `timezone=${Intl.DateTimeFormat().resolvedOptions().timeZone}`,
        'Accept-Language': this.#language()
      },

      withCredentials: true
    });
  }
  public ioRequest<Ev extends EventNames<ChatWsEmitEventsMap>>(
    event: Ev,
    args?: Parameters<ChatWsEmitEventsMap[Ev]>[0]
  ): Observable<ReturnType<ChatWsEmitEventsMap[Ev]>> {
    return new Observable<ReturnType<ChatWsEmitEventsMap[Ev]>>((observer) => {
      this.io
        .emitWithAck(event, ...([args] as Parameters<typeof this.io.emitWithAck>[1]))
        .then((response: ChatWsResponse<Ev>) => {
          if (response?.error) {
            console.error('WebSocket response error:', response.error);
            observer.error(response.error);
          } else observer.next(response.result);
          observer.complete();
        })
        .catch((error: unknown) => {
          console.error('WebSocket request error:', error);
          observer.error(error);
        });
    });
  }
}
